import type { Papel } from '../types/usuario'

/**
 * O que cada papel permite, em linguagem de quem não é de TI.
 *
 * Mora em `lib/` porque é lido de dois lados da tela: a administração, onde alguém CONCEDE o
 * papel, e "Minha conta", onde a própria pessoa descobre o que o papel dela quer dizer. O texto
 * tem de ser o mesmo nos dois — administrador e usuário discutindo acesso com definições
 * diferentes é como se descobre que a explicação foi escrita duas vezes.
 *
 * Quem concede papel precisa entender a diferença entre solicitar e executar uma mudança: no
 * sistema anterior os dois eram o mesmo perfil, e quem executava homologava o próprio trabalho.
 */
export const EXPLICACAO_DO_PAPEL: Record<Papel, { rotulo: string; ajuda: string }> = {
  ADMIN: {
    rotulo: 'Administrador',
    ajuda: 'Cadastra pessoas, concede papéis e destrava situações excepcionais. Dê a poucas pessoas.',
  },
  FISCAL: {
    rotulo: 'Fiscal do contrato',
    ajuda:
      'Registra a análise de cada chamado, carrega a planilha e fecha o mês. É o julgamento dele que vira ' +
      'indicador e desconto na nota.',
  },
  FISCAL_REQUISITANTE: {
    rotulo: 'Fiscal requisitante',
    ajuda:
      'Assina a ordem de serviço ao lado do gestor do contrato. Marcar aqui NÃO libera nada no ' +
      'sistema: é o registro de quem tem essa atribuição no contrato. O termo de referência cria ' +
      'essa assinatura e não diz de quem ela é — por isso a ordem de serviço continua guardando o ' +
      'nome e a matrícula como texto, digitados por quem a registra.',
  },
  CAB_PRESIDENTE: {
    rotulo: 'Presidente do comitê',
    ajuda:
      'Pauta as solicitações na reunião e aprova ou recusa uma mudança — só ele e o suplente fazem isso. Sem ' +
      'um dos dois, nada chega a produção.',
  },
  CAB_PRESIDENTE_SUPLENTE: {
    rotulo: 'Presidente suplente do comitê',
    ajuda:
      'Substitui o presidente quando ele não está: pauta, aprova, recusa e revoga com os mesmos poderes. O ' +
      'sistema não sabe quem faltou à reunião — por isso cada decisão fica registrada com o nome de quem a tomou.',
  },
  CAB_MEMBRO: {
    rotulo: 'Membro do comitê',
    ajuda: 'Participa da avaliação, pede mais informações e valida a execução — mas não aprova sozinho.',
  },
  GMUD_SOLICITANTE: {
    rotulo: 'Solicitante de mudança',
    ajuda: 'Abre a solicitação, preenche o plano e envia ao comitê. É o papel da equipe que pede a mudança.',
  },
  GMUD_EXECUTOR: {
    rotulo: 'Executor da mudança',
    ajuda:
      'Executa em produção o que o comitê aprovou e registra o resultado. É o papel da contratada — e ele ' +
      'não valida o próprio trabalho.',
  },
  LEITOR: {
    rotulo: 'Somente consulta',
    ajuda: 'Vê as telas e não registra nada. É o que toda conta nova recebe até alguém decidir o contrário.',
  },
}
